<template>
  <div>
    <NavigationBar
      titel="Konfiguration"
      :tabs="tabs"
      :activeTab="activeTab"
    ></NavigationBar>
    <router-view />
  </div>
</template>

<script>
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";

export default {
  name: "scheduling-config",
  components: {
    NavigationBar,
  },
  data() {
    return {
      activeTab: `config/general`,
      tabs: [
        { id: 1, name: "Allgemein", route: `general` },
        { id: 2, name: "Veranstaltungsarten", route: `event-types` },
        { id: 3, name: "Abfragearten", route: `request-types` },
        { id: 4, name: "Vorlagen", route: `templates` },
      ],
    };
  },
};
</script>
